module.exports = __webpack_public_path__ + "media/images/invite_health_teams-c653a809.svg";